import React from 'react';
import clsx from 'clsx';

export default function TenantWordmark({
  cityName,
  label = 'SPOTLIGHT',
  className = '',
  cityClassName = '',
  labelClassName = '',
  cityColor = 'var(--primary)',
  labelColor = '#1F2937',
}) {
  const resolvedCityName = String(cityName || '').trim() || 'My Town';
  const resolvedLabel = String(label || '').trim() || 'SPOTLIGHT';

  return (
    <div className={clsx('leading-none', className)} aria-label={`${resolvedCityName} ${resolvedLabel}`}>
      <div
        className={clsx('font-logo text-[2.3rem] leading-[0.78] sm:text-[2.7rem]', cityClassName)}
        style={{
          color: cityColor,
          textShadow: '0 1px 0 rgba(255,255,255,.35)',
        }}
      >
        {resolvedCityName}
      </div>
      <div
        className={clsx('font-logo-subtitle mt-0.5 text-[0.6rem] leading-none sm:text-[0.7rem]', labelClassName)}
        style={{ color: labelColor }}
      >
        {resolvedLabel}
      </div>
    </div>
  );
}
